import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { switchMap } from 'rxjs/operators';
import { APP_CONFIG, AppConfiguration } from 'src/app/types/app-configuration';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const config = inject<AppConfiguration>(APP_CONFIG);
  const oidc = inject(OidcSecurityService);
  return oidc.getAccessToken().pipe(switchMap(accessToken => {
    const request = config.apiRootUrl != null && req.url.startsWith(config.apiRootUrl) ?
      req.clone({ headers: req.headers.set('Authorization', `Bearer ${accessToken}`) }) : req.clone();
    return next(request);
  }));
};
